import React from "react"
import { Col, Row, Form, Dropdown } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "./formLabel"

function FormDropdownList(props) {
  const {
    textDesc,
    form,
    field,
    dropdownItem,
    // coverageCategory,
    // coverageCode,
    // extraFieldValue,
    // affectedField,
  } = props

  const errorsMsg = getIn(form.errors, field.name)
  // const touched = getIn(form.touched, field.name)

  const inputErrorMessage = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  const DropdownValueChange = description => {
    form.setFieldValue(field.name, description)
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <Dropdown className="dropdown">
            <Dropdown.Toggle
              disabled={props.disabled}
              className={
                (props.disabled ? "disableBGcolor " : " ") +
                "btn btn-secondary dropdown-toggle DropdownHeader"
              }
            >
              {field.value}
              {/* {dropDownValue} */}
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu DropdownMenu">
              {dropdownItem.map((item, key) => (
                <Dropdown.Item
                  key={key}
                  //onClick={DropdownValueChange.bind(this, item.Description)}

                  onClick={() => {
                    DropdownValueChange(item.Description, form)
                    form.setFieldValue(
                      field.name,
                      item.Description,
                      true /* force validation */
                    )
                  }}
                >
                  {item.Description}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {/* {errors && touched && <span className="InputError">{errors}</span>} */}
          {/* <span className="InputError">{errors}</span> */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default FormDropdownList
